import React, { useState, useEffect, useRef } from 'react';
import GymNavbar from '../components/navbar'
import GymHerosection from '../components/herosection'
import PlanCard from '../components/PlanCard'
import GymContact from '../components/ContactForm'
import GymFooter from '../components/footer'
import { createGymHomePage, getGBussinessInfo, getGymAddonsList, getGymHomePage, getGymPlansList } from '../../services/apiServices';
import { defaultPageInfo } from '../../utils/defaultPageInfo';
import { getBussinessInfobyUrl } from '../../services/classApiServices';


function GymHome() {
  
    const [pageData, setPageData] = useState(defaultPageInfo);
    const [bussinessinfo, setbusinessinfo] = useState(null)
    console.log("bussinessinfo", bussinessinfo)
    const hostname = window.location.hostname;
    let subdomain = "";
    console.log(hostname, 'hostname');

    if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
        const parts = hostname.split('.');
        if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta") {
            subdomain = parts[0];
        }
    }


    console.log('Subdomain:', subdomain);

    // const navigate = useNavigate();
    useEffect(() => {
        const fetchBusiness = async () => {
            const identifier = subdomain;
            const type = subdomain ? 'subdomain' : 'prefix';

            const response = await getBussinessInfobyUrl(identifier, type);
            if (!response || response === "false") {
                return;
            }

            const businessInfo = await response.json();
            console.log(businessInfo);
            setbusinessinfo(businessInfo);
        };

        if (subdomain !== "") {
            fetchBusiness();
        }
    }, []);

    useEffect(() => {
        async function fetchData() {

            const response = await getGymHomePage(
                bussinessinfo?._id
            );
            if (response && response !== "false") {
                const tempData = await response.json();
                console.log(tempData, 'tempData')

                setPageData(tempData);
            }
        }
        if (bussinessinfo?._id) {
            fetchData();
        }

    }, [bussinessinfo]);

    const [membership, setMembership] = useState([])

    console.log("membership", membership)




    useEffect(() => {
        if (!bussinessinfo?._id) return;

        const fetchPlansAndAddons = async () => {
            try {
                let mergedMembership = [];


                const plansResponse = await getGymPlansList(bussinessinfo._id);
                if (plansResponse?.ok) {
                    const plansData = await plansResponse.json();

                    const formattedPlans = plansData.flatMap(plan => {
                        if (plan.archived) return [];

                        if (Array.isArray(plan.subplans) && plan.subplans.length > 0) {
                            return plan.subplans.map(subplan => ({
                                ...subplan,
                                type: "plan",
                                displayName: `${plan.name} - ${subplan.name}`,
                            }));
                        }

                        return [{
                            ...plan,
                            type: "plan",
                            displayName: plan.name,
                        }];
                    });

                    mergedMembership.push(...formattedPlans);
                }

                const addonsResponse = await getGymAddonsList(bussinessinfo._id);
                if (addonsResponse?.ok) {
                    const addonsData = await addonsResponse.json();

                    const enabledAddons = addonsData
                        .filter(addon => addon.enable)
                        .map(addon => ({
                            ...addon,
                            type: "addons",
                            displayName: addon.name,
                        }));

                    mergedMembership.push(...enabledAddons);
                }

                console.log("Final membership data:", mergedMembership);
                setMembership(mergedMembership);

            } catch (error) {
                console.error("Error fetching plans or addons:", error);
            }
        };

        fetchPlansAndAddons();
    }, [bussinessinfo?._id]);


    const homeRef = useRef(null);
    const plansRef = useRef(null);
    const contactRef = useRef(null);


    const scrollToRef = (ref) => {
        const navbarHeight = 56;
        window.scrollTo({
            top: ref.current.offsetTop - navbarHeight,
            behavior: 'smooth'
        });
    };

    const isHiden = {
        plans: pageData?.plans?.isactive ? false : true,
        contact: pageData?.contact?.isactive ? false : true
    }

    return (
        <div>
            <GymNavbar
                scrollToHome={() => scrollToRef(homeRef)}
                scrollToPlans={() => scrollToRef(plansRef)}
                scrollToContact={() => scrollToRef(contactRef)}
                isHiden={isHiden}
                logourl={bussinessinfo?.logourl}
            />
            <div ref={homeRef}>
                <GymHerosection pageData={pageData} />
            </div>

            <div ref={plansRef}>
                {pageData?.plans?.isactive ? < PlanCard planData={pageData?.plans} membership={membership} /> : <></>}
            </div>

            <div ref={contactRef}>
                {pageData?.contact?.isactive ? <GymContact contactData={pageData?.contact} bussinessinfo={bussinessinfo} /> : <></>}
            </div>

            {pageData?.footer?.isactive ? <GymFooter footerData={pageData?.footer} bussinessinfo={bussinessinfo} /> : <></>}
        </div>
    )
}

export default GymHome
